import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  getBullionRequest,
  getBullionSuccess,
  getBullionFailure,
  updateBullionTaxRequest,
  updateBullionTaxSuccess,
  updateBullionTaxFailure,
   getBullionMarginsRequest,
    getBullionMarginsSuccess,
    getBullionMarginsFailure,
} from "./BullionSlice";
import { getMetals } from "../slices/manageMetals";

const getBullion = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/createProduct`,
    payload,
  );
  return response.data;
};

function* handleAddBullion(action) {
  try {
    const response = yield call(getBullion, action.payload);
    yield put(getBullionSuccess(response));
    // yield call(toast.success, 'Get enabled metals success');
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to get enabled metals";
    yield put(getBullionFailure(message));
    yield call(toast.error, message);
  }
}

const updateBullionTaxApi = async ({ bullionId, data }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/updateBullionTax?bullionId=${bullionId}`,
    data,
  );
  return response.data;
};
function* handleUpdateBullionTax(action) {
  try {
    const response = yield call(updateBullionTaxApi, action.payload);

    if (response?.success) {
      yield put(updateBullionTaxSuccess(response));
      yield call(toast.success, response.message || "Bullion tax updated");
      yield put(getMetals({}));
    } else {
      yield put(updateBullionTaxFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to update bullion tax";

    yield put(updateBullionTaxFailure(message));
    yield call(toast.error, message);
  }
}

const getBullionMarginsApi = async ({ page, limit ,search}) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/bullionMargins?page=${page}&limit=${limit}&search=${search}`,
  );
  return response.data;
};
function* handleGetBullionMargins(action) {
  try {
    const response = yield call(getBullionMarginsApi, action.payload);
    console.log("Bullion Margins Response:", response);

    if (response?.success) {
      yield put(getBullionMarginsSuccess(response.data));
    } else {
      yield put(getBullionMarginsFailure(response.message));
      yield call(toast.error, response.message);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch bullion margins";

    yield put(getBullionMarginsFailure(message));
    yield call(toast.error, message);
  }
}

export default function* bullionSaga() {
  yield takeLatest(getBullionRequest.type, handleAddBullion);
  yield takeLatest(updateBullionTaxRequest.type, handleUpdateBullionTax);
  yield takeLatest(getBullionMarginsRequest.type, handleGetBullionMargins);
}
